import React from 'react';
import { Router, Route, Switch } from 'dva/router';
import { LocaleProvider } from 'antd';
import ja_JP from 'antd/lib/locale-provider/ja_JP';

import ContactPage from '../components/ContactPage';

function RouterConfig(props) {
  return (
    <LocaleProvider locale={ja_JP}>
    <Router history={props.history}>
      <Switch>
        <Route path="/school" render={() => <ContactPage appKey={props.app.appkey} />} />
        <Route exact path="/api/contacts" render={() => <ContactPage appKey={props.app.appkey} />} />
      </Switch>
    </Router>
    </LocaleProvider>
  );
}

export default RouterConfig;



// WEBPACK FOOTER //
// ./src/pages/contact/config/router.js